<template>
	<div>
		<Affix>
			<div class="header" style="background-color: #fff;">
				<Row type="flex" justify="space-between">
					<Col span="4">
					<span class="navbar-brand" style="padding-left: 10px;">
						<img class="logo" src="../../assets/logo.png" />
					</span>
					</Col>
					<Col span="4" style="text-align: center;padding-top: 4px;">
					<Icon @click="openNews = true" size="30" type="md-menu" />
					</Col>
				</Row>

			</div>
		</Affix>
		<div style="padding: 10px;">
			<img style="width: 100%;border-radius: 10px;" src="../../assets/4.jpg"  />
			<Breadcrumb style="margin:10px 0px;">
				<BreadcrumbItem to="/m/index">首页</BreadcrumbItem>
				<BreadcrumbItem>关于汇金</BreadcrumbItem>
			</Breadcrumb>
			<Row type="flex" justify="center">
				<Col span="24">
					<div class="ytitle">
						<div class="item" :class="showIndex==0?'cheak':''" @click="showIndex=0">公司简介</div>
						<div class="item" :class="showIndex==1?'cheak':''" @click="showIndex=1">发展历程</div>
						<div class="item" :class="showIndex==2?'cheak':''" @click="showIndex=2">荣誉历史</div>
						<div class="item" :class="showIndex==3?'cheak':''" @click="showIndex=3">社会责任</div>
						<div class="item" :class="showIndex==4?'cheak':''" @click="showIndex=4">党建工作</div>
					</div>
			
				</Col>
			</Row>
			<div style="padding: 10px;" v-if="showIndex==0">
				<p>
					汇金永信保险销售服务有限公司成立于2011年10月8日，是一家全国性的专业化保险销售服务公司。公司经营范围：在全国区域内（港、澳、台除外）代理销售保险产品；代理收取保险费；代理相关保险业务的损失勘查和理赔；中国保监会批准的其他业务。<br>
					截止到2023年2月，公司拥有内外勤员工5000人；已在四川、重庆、江苏、北京、上海、天津、河北、山东、青岛、河南、湖南等省、市开设分支机构68家，多家省市级分公司正在筹建中。<br>
					上级股东单位四川正和祥健康药房连锁，集团旗下拥有9家零售连锁公司、1家加盟连锁公司、1家批发公司、1家诊所连锁公司、1家中药生产企业和1家保险销售公司。股东旗下有5000余家医药门店覆盖四川、贵州、湖南、重庆等地。公司目前分别与正和祥、楚济堂、睿保医云建立了深度的战略合作机制。<br>
					公司的经营理念：阳光创业、永续经营；公司的核心价值观：诚信、创新、专业、服务；公司愿景：让保险助力亿万家庭幸福生活！公司使命：为伙伴搭建永续的经营平台，为大众提供专业的保险服务。<br>
					公司根据目前市场现状，并结合自身特点，提出“以寿险综合开拓为主，以非寿险为辅”的指导思想。公司重点关注业务品质，个人寿险13J继续率持续保持在96%以上。<br>
					公司具有全国互联网销售资质：公司运营的移动互联网平台“畅快保”，实现B端、C端分层级运用；着眼于大数据分析，为客户提供一站式优质保险服务，为员工提供先进的展业工具，现已初见成效。<br>
					公司自主研发的核心业务系统实现了寿险、团财险、互联网业务管理标准化、系统化，集成了业务管理、人员管理、财务管理等核心模块于一体，符合国家及银保监对保险专业中介对信息化安全的要求。获得国家公安部颁发的《信息系统安全等级保护三级备案证明》。2021年12月已顺利通过监管部门验收，成为《四川省保险专业中介机构信息化白名单》首批成员。<br>
					未来展望：公司预计在未来五年的发展期内，实现寿险保费业务产值累计10亿元，非寿险保费产值累计50亿元；建设省级分支机构20家，地市级分支机构60家，未来五年完成在全国二线城市以上重点区域布局，公司着力打造西南地区第一保险销售服务品牌。
												
				</p>
			</div>
			<div style="padding: 10px;" v-if="showIndex==1">
				<div style="margin: 0 auto;width: 400px;margin-top: 0px;">
					<Timeline>
						<TimelineItem>
							<p class="time">2023.01.17 </p>
							<p class="content">四川分公司乔迁新址；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022.11.04 </p>
							<p class="content">汇金营销期刊创刊发布；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022.07 </p>
							<p class="content"> 汇金永信2022年寿险新单承保保费突破1亿元；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022.07.22 </p>
							<p class="content">董事长当选四川省保险中介行业协会会长；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022.05.17 </p>
							<p class="content"> 四川银保监局莅临汇金永信调研；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2021.09.02 </p>
							<p class="content"> 湖南分公司开业；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2021.08.04 </p>
							<p class="content"> 畅快保APP公测上线运营；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2021.01.01 </p>
							<p class="content">四川分公司开业；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019.09.17 </p>
							<p class="content"> 河南分公司开业；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019.09.05 </p>
							<p class="content"> 畅快保公众号升级运营；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018.09.28 </p>
							<p class="content"> 青岛分公司开业；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018.08.10 </p>
							<p class="content"> 天津分公司开业；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018.06 </p>
							<p class="content"> 上海、北京、河北、山东分公司先后开业；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2017.12.14 </p>
							<p class="content">畅快保公众号开通运营；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2017.11.16 </p>
							<p class="content"> 江苏分公司成立；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2017.04.25 </p>
							<p class="content"> 重庆分公司成立；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2013.04.21 </p>
							<p class="content"> 公司组织参加“4.20芦山地震”抗震救灾活动；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2013.01.24 </p>
							<p class="content"> 公司更名为汇金永信保险销售服务有限公司并变更经营范围为全国；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2011.08.31 </p>
							<p class="content">公司注册资本增资至5000万元；</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2011.10.08 </p>
							<p class="content">四川汇金永信保险代理有限公司批准成立；</p>
						</TimelineItem>
					</Timeline>
				</div>
			</div>
			<div v-if="showIndex==2">
				<div style="margin: 0 auto;width: 400px;margin-top: 20px;">
					<Timeline>
						<TimelineItem>
							<p class="time">2022 </p>
							<p class="content">当选四川保险中介行业协会“会长单位”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022 </p>
							<p class="content">获得华泰财险“最佳合作伙伴”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022 </p>
							<p class="content">获得四川银行业保险业2022年清廉文化知识竞赛“优秀组织奖”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2021 </p>
							<p class="content">获得恒大人寿“经英推广大使”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2021 </p>
							<p class="content">获得工银安盛人寿“优秀合作单位”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019 </p>
							<p class="content">获得陆家嘴国泰人寿“优秀合作单位”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019 </p>
							<p class="content">获得恒大人寿“优秀合作机构奖”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019 </p>
							<p class="content">获得天安人寿“续期品质优秀奖”</p>
						</TimelineItem>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019 </p>
							<p class="content">获得恒安标准人寿“精诚合作奖”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2019 </p>
							<p class="content">获得陆家嘴国泰人寿“优秀合作渠道”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">获得众安在线“优秀合作伙伴奖”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">获得中意人寿“年度优秀合作商”</p>
						</TimelineItem>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">当选四川省保险中介行业协会“副会长单位”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">获得陆家嘴国泰人寿“卓越合作渠道”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">获得恒大人寿“最佳品质合作机构奖”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">获得中意人寿“年度优秀合作商”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2018 </p>
							<p class="content">获得泰康人寿“卓越合作渠道”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2017 </p>
							<p class="content">获得中英人寿“中英经代最佳合作伙伴”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2017 </p>
							<p class="content">获得恒大人寿“杰出合作机构奖”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2016 </p>
							<p class="content">年荣获同方全球人寿“最佳贡献合作商”</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2013 </p>
							<p class="content">年荣获中意人寿经销宝“出单最多的合作公司”</p>
						</TimelineItem>
					</Timeline>
				</div>
			</div>
			<div v-if="showIndex==3">
				<div style="width: 100%;padding: 10px;;font-size: 16px;margin-bottom: 20px;">
					<p>
						我们认为，作为一个有良心和有远见的企业，我们不仅要为股东创造价值，也要为员工、客户、合作伙伴和社会创造价值。<br>
						我们秉持“正直向善、科技创新、创造价值、担当责任、合作共赢”的社会责任理念。我们相信，只有承担相应的社会责任，才能实现各个方面的共赢。
					</p>
				</div>
				<div style="margin: 0 auto;width: 400px;margin-top: 20px;">
					<Timeline>
						<TimelineItem>
							<p class="time">2022年12月 </p>
							<p class="content">汇金永信为员工采购抗疫药品</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022年9月 </p>
							<p class="content">汇金永信员工参与社区抗疫</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2022年2月 </p>
							<p class="content">汇金永信上分员工参与社区抗疫</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2021年7月8日 </p>
							<p class="content">汇金永信参与“7.8保险公众宣传日</p>
						</TimelineItem>
						<TimelineItem>
							<p class="time">2020年 </p>
							<p class="content">汇金永信四川分公司去往养老院慰问</p>
						</TimelineItem>
					</Timeline>
				</div>
			</div>
			<div v-if="showIndex==4">
				<Card v-for="(item,index) in data1" >
					 <p slot="title" @click="goPage(item.id)">
						 <Icon type="ios-square" color="#FF6633"/>
						 {{item.title}}
					 </p>
					 <div class="newsBody"><p>{{delHtmlTag(item.body)}}</p> </div>
					 <div>{{getYYYYMM(item.createTime)}}-{{getDD(item.createTime)}}</div>
				</Card>
				
				<div v-if="data1.length==0" style="text-align: center;color: #d7dde4; padding: 100px;">暂无新闻</div>
				<Page :total="total" show-total style="margin-top: 20px;margin-bottom: 20px;"
					@on-change="goNextPage" />
			</div>
		</div>
		<div style="width: 100%;height: 300px;background-color: #f6f7f9;padding-top: 20px;">
			<Row type="flex" justify="center" align="middle" >
				<Col span="16">
				2022 &copy; 汇金永信保险销售服务有限公司<br>
				地址：四川省成都市高新区府城大道中段88号中航城市广场1205室<br>
				联系方式：028-85224343
				邮件：hjyxcoltd@163.com<br>
				网站版权所有 hjyxbx.com 所有
				Copyright © 2013 蜀ICP备13002380号  
				</Col>
				<Col span="16" style="text-align: center;">
				<img src="../../assets/erweima.jpg" style="width: 100px;margin-top: 10px;" />
				</Col>
			</Row>
		</div>
		<Drawer :width="200" :closable="false" v-model="openNews">
			<List>
				<ListItem>
					<router-link to='/m/index'>
						首页
					</router-link>
				</ListItem>
				<ListItem>
					<router-link to='/m/us'>
						关于汇金
					</router-link>
				</ListItem>
				<ListItem v-for="(item,index) in titleList" :name="item.id" v-if="item.id<100">
					<router-link :to='"/m/list?id="+item.id'>
						{{item.name}}
					</router-link>
				</ListItem>
				<ListItem >
					<router-link to='/m/map'>
					联系我们
					</router-link>
				</ListItem>
			</List>
		</Drawer>
		<BackTop></BackTop>
	</div>
</template>
<script>
	import {
		sendMsg
	} from '../../api/index.js'
	import moment from 'moment'
	import striphtml from 'js-striphtml'
	export default {
		data() {
			return {
				showIndex: 0,
				acvtion: "ss_104",
				columns1: [{
						title: '标题',
						key: 'title'
					},
					{
						width: 200,
						title: '创建时间',
						key: 'createTime',
						render: (h, dto) => {
							return h('div', [h('span', moment(dto.row.createTime).format('YYYY-MM-DD hh:mm:ss'))])
						},
						sortType: "desc",
						align: "right"
					}
				],
				data1: [],
				openNews: false,
				showbody: {},
				titleList: [],
				total: 0,
				page: 1,
				typeID: 105,
				pageWhere: "关于汇金"
			}
		},
		watch: {
			$route: { // 亲测有效,我是用来监听query参数变化
				handler() {
					this.typeID = this.$route.query.id;
					this.initData()

				},
				deep: true,
			}
		},
		created() {
			this.initData()

		},
		mounted() {

		},
		updated() {

		},


		methods: {
			delHtmlTag(str) {
				return str.replace(/<[^>]+>/g, '')
			},
			getDD(e) {
				return moment(e).format('DD')
			},
			getYYYYMM(e) {
				return moment(e).format('YYYY-MM')
			},

			showTable(e) {
				this.openNews = true
				this.showbody = e
			},
			goNextPage(e) {
				this.page = e;
				console.info(this.page)
				this.initData()
			},
			menuChange() {
				this.acvtion = 'ss_' + this.typeID
				this.$nextTick(() => {
					this.$refs.menus.updateOpened()
					this.$refs.menus.updateActiveName();
				})
			},
			goPage(e) {
				this.$router.push({
					path: '/m/detal?id=' + e
				})
			},
			initData() {
				let that = this
				sendMsg("/baseNews/list", {
					limit: 10,
					page: this.page,
					type: this.typeID
				}, 'POST', false).then(res => {
					this.data1 = res.data.data
					this.total = res.data.count
				})
				sendMsg("/baseType/list", {}, "POST", false).then(res => {
					this.titleList = res.data.data
					for (var i = 0; i < res.data.data.length; i++) {
						console.info(res.data.data[i].id)
						if (res.data.data[i].id == that.typeID) {
							console.info(res.data.data[i].name)
							that.pageWhere = res.data.data[i].name
						}

					}
				})
			},
		},
		components: {
			sendMsg
		}
	}
</script>

<style>
	.container {
		width: 100%;
		margin-right: auto;
		margin-left: auto;
		max-width: 1140px;
	}

	.header {
		background-color: transparent;
		padding: 0;
		height: 90px;
		display: grid;
		align-items: center;
	}

	.container__wrapper--center {
		margin: 0 auto;
	}

	.navbar {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
	}

	.navbar-expand-lg {
		width: 100%;
		min-width: 992px;
		flex-flow: row nowrap;
		justify-content: flex-start;
	}

	.navbar .navbar-brand {
		margin: 2px 0 0;
		padding: 0;
		font-size: 22px;
		color: #fff;
		font-weight: 800;
		text-transform: uppercase;
	}

	a {
		text-decoration: none;

	}


	a:hover {
		background: linear-gradient(#FF6600, #FF6633);
		color: #FFFFFF !important;
	}

	.logo {
		width: auto;
		height: 40px;
	}

	.navbar-nav {
		display: flex;
		flex-direction: row;
		padding-left: 0;
		margin-bottom: 0;
		list-style: none;
		align-items: center;
		margin-left: auto !important;
		height: 80px;
	}

	.navbar-collapse {
		-ms-flex-preferred-size: 100%;
		flex-basis: 100%;
		-ms-flex-positive: 1;
		flex-grow: 1;
		-ms-flex-align: center;
		align-items: center;
	}

	.navbar-expand-lg .navbar-collapse {
		display: -ms-flexbox !important;
		display: flex !important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto;
	}

	.navbar-nav .nav-item {
		padding: 0 18px;
		transition: all .5s ease;
		position: relative;

	}

	.navbar-nav .nav-item :hover::before {
		position: absolute;
		top: 40px;
		right: calc(50% - 10px);
		width: 20px;
		height: 3px;
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAA+CAMAAACRDYw7AAAAQlBMVEUAAAAAAADyhy35vWP4vGP2qk/0mDz4u2H1okj3rlP1pkv0m0D4t1z1n0T3tFn3sVfzlDnzkTbyii/yjjPyjDHyhyxN587IAAAABXRSTlMAArW1tP5J36kAAACnSURBVFjD7dZbCoMwEIXhamuuJtFo9r/VUgMHH2otysAE5l/ARxhye0iSJElSG3W7iGREQyMSG9HQiMRGJDZii3enscT7kvO6LPM8TUop730Ixhjn3DAM1toUYxxHrZ+X8PLB1yM8pVRxfQ3P31ZebTK86pt9Ay/bVICHEGDfxnssHPhuLJjKi99W/AvnevxPcb5X7m+d9zN3qLfwtYAPWZIkSZKa6A0wZw0kr1ugbQAAAABJRU5ErkJggg==) no-repeat 50%;
		content: "";
		border-radius: 4px;
	}

	.navbar-expand-lg .navbar-nav .nav-link {
		padding: 6px 7px;
		font-size: 16px;
		border-bottom: 1px solid transparent;
		opacity: .8;
		color: #000;
		border-radius: 4px;
	}

	.navbar-expand-lg .navbar-nav .active {}
	
	.ytitle {
		width: 100%;
		text-align: center;
		height: 30px;
		margin-bottom: 20px;
		margin-top: 20px;
	}
	
	.ytitle .item {
		width: 20%;
		float: left;
		height: 30px;
		font-size: 16px;
		line-height: 30px;
		cursor: pointer;
	}
	
	.cheak {
		color: #2d8cf0;
	
	}
	
	.cheak::before {
		content: "";
		display: inline-block;
		width: 64px;
		height: 4px;
		position: absolute;
		bottom: 18px;
		background-color: #FF6600;
		margin-right: 6px;
	}
	
	.newsBody p {
		position: relative;
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
	}
	
	.newsBody p::after {
		content: "...";
		position: absolute;
		bottom: 0;
		right: 0;
		padding-left: 40px;
		background: -webkit-linear-gradient(left, transparent, #fff 55%);
		background: -o-linear-gradient(right, transparent, #fff 55%);
		background: -moz-linear-gradient(right, transparent, #fff 55%);
		background: linear-gradient(to right, transparent, #fff 55%);
	}
</style>
